import React, { Component } from 'react';
import { connect } from 'react-redux'
import { agentChat, supervisorChat } from '../../../Images/Images';
import { supervisorChatSVG, supervisorChatSimpleSVG } from '../../../Images/ChatSVG';
import { arrowBack, send } from '../../../Images/GenericSVG';
import { messageToSupervisor } from '../../../redux/actions/A_messages_to_SM';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import { Singleton } from '../../../js/Singleton';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import TextareaAutosize from 'react-autosize-textarea';
import { consultingApp, noConsultingApp } from '../../../redux/actions/A_reducer_consulting';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { INTEGRATION, INTEGRATION_SUBACTION, DRAGGABLE_WINDOWS } from '../../../constants';
import { changeIsIntegration } from '../../../redux/actions/A_actions_Integration';
import { Logger } from '../../../js/helpers/Logger.js';

class SupervisorChat extends Component {
  constructor(props) {
    super(props);
    this.timmeropenChatFromNotification = null;
    this.timmerSendChatToAdmin = null;
    this.timmerFocusArea = null;
    this.timerScrollToBottom = null;
    this.isFirstOpenSupervisor = false;
    this.sharedData = new SingletonSharedData();
    let supervisorName = this.props.objProps ? this.props.objProps.currentSupervisor : this.sharedData.currentSupervisor;
    let screenChat = this.props.objProps ? this.props.objProps.screenChat : false;
    this.state = {
      screenSelectionChat: !screenChat,
      currentSupervisor: supervisorName,
      windowType: (this.props.floating ? "floating" : "expanded"),
      textToSend: "",
      arrayChat: this.sharedData.getChatList(supervisorName),
      superVisorChatList: [],
    }
    this.adminWithNotification = undefined;
    this.NumberAdminWithNotification = 0;
    this.language = new Singleton();
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.isRender = false;
    let _this = this;
    if (!this.props.floating) {
      this.sharedData.observerSupervisor((supervisorList) => _this.setState({ superVisorChatList: supervisorList }));
    }
    this.indexChats = 0;
    this.componentVisible = false;
    this.OPEN_CHAT = {
      "expanded": (that) => {
        if (that.NumberAdminWithNotification === 1) {
          that.selectChat(that.adminWithNotification);
          that.sharedData.setNewNotificationChat(that.adminWithNotification.Username, true);
        }
      },
      "floating": (that) => {
        if (that.NumberAdminWithNotification === 1) {
          that.sharedData.setCurrentSuperVisor(that.adminWithNotification.Username);
          that.openChatFromNotification();
        }
      }
    }
    this.resize = this.resize.bind(this);
  }

  componentDidMount() {
    this.isRender = true;
    let objectResponse = this.apiCont.getObjectResponse();
    let _this = this;
    
    Logger.Trace("[ChatComponent][componentDidMount] Search List Supervisor ===>>");
    this.apiCont.getSupervisorList(this.sharedData.getParameters().UserID, objectResponse);
    this.props.consultingApp();
    objectResponse.onError = function (messageError) {
      Logger.Warn("ERROR List Supervisor ===>>", messageError);
      _this.props.noConsultingApp();
      if (_this.state.windowType === "floating") {
        var errorMessage = _this.language.getText("error-" + messageError.InternalCode);
        var errorObject = SingletonWebSocket.getJsonError(messageError.InternalCode, errorMessage);
        SingletonWebSocket.send(
          SingletonWebSocket.getJson(INTEGRATION.CHAT,
            INTEGRATION_SUBACTION.ERROR_SUPERVISOR_LIST_EVENT, errorObject));
      }
    };
    objectResponse.onSuccess = function (objResponse) {
      Logger.Trace("Admins List ", objResponse.Response);
      if (_this.state.windowType === "floating") {
        SingletonWebSocket.send(
          SingletonWebSocket.getJson(INTEGRATION.CHAT, INTEGRATION_SUBACTION.CHAT_SUPERVISORS, objResponse.Response));
      }
      if (_this.isRender) {
        _this.setState({ superVisorChatList: objResponse.Response });
      } 
   

      _this.sharedData.setSupervisorList(objResponse.Response);
      let supervisorList = _this.sharedData.getSupervisorList();
      _this.props.noConsultingApp();
      _this.findAdminsWithNotification(supervisorList);
      _this.OPEN_CHAT[_this.state.windowType](_this);
    };
    if (this.sharedData.getWindowChatOpen()) {
      this.openChatFromNotification();
    }
    window.addEventListener('resize', this.resize);
  }

  shouldComponentUpdate(nextProps, nextstate) {
    const objProps = nextProps.objProps
    if(objProps && objProps.regsMultiple){
      return true
    }
    let isVisiable = (nextProps.floating && window.innerWidth < 1300) || (!nextProps.floating && window.innerWidth >= 1300)
    if (!isVisiable || nextstate.superVisorChatList.length === 0) {
      return false;
    }
    return true;
  }
  componentWillReceiveProps(nextProps) {

    let _this = this;
    
    let supervisor = nextProps.stateMachineActions.supervisor;
    if (supervisor && supervisor === this.state.currentSupervisor) {
      let arrayChat = _this.sharedData.getChatList(supervisor);
      if (arrayChat.length !== _this.state.arrayChat.length) {
        _this.setState({ arrayChat: arrayChat });
      }
    }
    if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.dataMessageIntegration
      && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.CHAT
    ) {
      var adminName = nextProps.messagesIntegrations.dataMessageIntegration.data.chatId;
      var message = nextProps.messagesIntegrations.dataMessageIntegration.data.message;

      var filter = this.state.superVisorChatList.filter(function (item) { return item.Username === adminName });

      if (filter) {
        let elem = filter[0];
        this.selectChat(elem);
        if (this.state.windowType === "expanded") {
          this.timmerSendChatToAdmin = setTimeout(() => {
            this.sendChatToAdmin(elem.Username, message)
          }, 10);
        }
      }
    }
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  componentWillUnmount() {
    this.isRender = false;
    window.removeEventListener('resize', this.resize);
    clearTimeout(this.timmeropenChatFromNotification);
    clearTimeout(this.timmerSendChatToAdmin);
    clearTimeout(this.timmerFocusArea);
    clearTimeout(this.timerScrollToBottom);
    this.sharedData.observerSupervisor(null);
  }


  findAdminsWithNotification(supervisorList) {
    this.adminWithNotification = undefined;
    this.NumberAdminWithNotification = 0;

    for (var i in supervisorList) {
      let item = supervisorList[i];
      let numberNotification = this.sharedData.getNotificationChat(item.Username);
      if (numberNotification && numberNotification > 0) {
        this.adminWithNotification = item;
        this.NumberAdminWithNotification++;
      }
    }
  }

  openChatFromNotification() {
    let _this = this;
    let supervisor = this.sharedData.getCurrentSuperVisor();
    this.selectChat({ Username: this.sharedData.getCurrentSuperVisor() });
    this.timmeropenChatFromNotification = setTimeout(() => {
      _this.setState({ arrayChat: _this.sharedData.getChatList(supervisor) });
      _this.sharedData.setWindowChatOpen(false);
      _this.sharedData.setStateWindow(DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, true);
      _this.sharedData.setWindowExpandedActive(DRAGGABLE_WINDOWS.SUPERVISOR_CHAT)
    }, 10);
  }
  loadStates() {
    let supervisor = this.sharedData.getCurrentSuperVisor()
    if (supervisor) {
      this.setState({
        screenSelectionChat: false,
        currentSupervisor: supervisor,
        textToSend: this.sharedData.getTextToSend(),
        arrayChat: this.sharedData.getChatList(supervisor),
      });
    } else {
      this.setState({
        screenSelectionChat: true,
        currentSupervisor: "",
        textToSend: this.sharedData.getTextToSend(),
      });
    }
  }
  resize() {    
    if (this.props.floating) {
      if (window.innerWidth < 1300 ) {
        if (!this.componentVisible) {
          this.componentVisible = true;
          this.loadStates();
        }
      } else {
       this.componentVisible = false;
      }
    }
    else {
      if (window.innerWidth > 1300 ) {
        if (!this.componentVisible) {
          this.componentVisible = true;
          this.loadStates();
        }
      } else {
        this.componentVisible = false;
      }
    }
  }

  selectChat(supervisor) {
    let _this = this;
    this.sharedData.setCurrentSuperVisor(supervisor.Username);
    this.setState({
      screenSelectionChat: false,
      currentSupervisor: supervisor.Username,
      arrayChat: this.sharedData.getChatList(supervisor.Username)
    });

    this.timmerFocusArea = setTimeout(() => { _this.textarea.focus(); }, 200);
  }

  sendChatToAdmin(adminName, message) {
    var currentTime = new Date().toLocaleTimeString();
    let messageToList = { type: 2, text: message, user: this.sharedData.getUserData().Login, hour: currentTime };
    this.sharedData.setObjectChat(messageToList, adminName);
    this.props.messageToSupervisor(message, adminName);
    let supervisor = this.sharedData.getCurrentSuperVisor();
    this.setState({ arrayChat: this.sharedData.getChatList(supervisor) });
  }
  sendChat() {
    if (this.textarea.value !== "" && this.textarea.value !== "\n") {
      this.sendChatToAdmin(this.state.currentSupervisor, this.textarea.value);
    }
    this.textarea.value = "";
  }
  backToSelect() {
    this.setState({ screenSelectionChat: true });
    this.sharedData.setNewNotificationChat(this.state.currentSupervisor, true);
    this.sharedData.setCurrentSuperVisor("");
  }
  scrollToBottom() {
    if (this.refs["ChatArea"]) {
      let _this = this;
      this.timerScrollToBottom = setTimeout(() => {
        _this.refs["ChatArea"].scrollTop = (_this.refs["ChatArea"].scrollHeight * 1000.0);
      }, 10);
    }
  }
  saveText(eventText) {
    this.sharedData.setTextToSend(eventText);
  }
  handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      this.sendChat();
    }
  }

  GetListChat() {
    
    let listSupervisor = this.state.superVisorChatList.map((item) => {
      return <div className={"supervisorChatItem " + this.state.windowType} key={item.Username}
        onClick={() => {
          this.selectChat(item);
          this.sharedData.setNewNotificationChat(item.Username, true);
        }}>
        <div className={"iconSVGSuperVisor " + this.state.windowType}>{supervisorChatSVG}</div>
        <p className={"supervisorNameChat " + this.state.windowType}>{item.Username}</p>
        {this.sharedData.getNotificationChat(item.Username) > 0 && <p className={"notificationChatNumber " + (this.sharedData.getNotificationChat(item.Username) < 10 ? "circle" : (this.sharedData.getNotificationChat(item.Username) < 100 ? "ovale" : "bigOvale"))}>{this.sharedData.getNotificationChat(item.Username)}</p>}
        <div className={"flechaChat " + this.state.windowType}>{arrowBack}</div>
      </div>
    });
    
    return listSupervisor
  }

  render() {
    return (
      <div className={"chatComponent " + this.state.windowType}>
        <div className={"supervisorList " + (this.state.screenSelectionChat ? "showed" : "hidden")}>
          {!this.props.floating && CUSTOM_COMPONENTS["sideBarHeader"](supervisorChatSimpleSVG, this.language.getText("GUIChatwindowTitle"))}
          {this.GetListChat()}
        </div>
        <div className={"chatScreen " + (this.state.screenSelectionChat ? "hidden" : "showed")}>
          <div className={"chatScreenHeader " + this.state.windowType}>
            <div className={"backArrow " + this.state.windowType} onClick={() => this.backToSelect()}> {arrowBack} </div>
            <p className={"supervisorName " + this.state.windowType}>{this.state.currentSupervisor}</p>
            <div className={"supervisorChatImg " + this.state.windowType}>{supervisorChatSimpleSVG}</div>
          </div>
          <div className={"chatSpace " + this.state.windowType}>
            <div className="chatText" ref="ChatArea">
              {this.state.arrayChat.map((item) =>
                <div className={"chatGlobeContainer " + (item.type === 2 ? "agent" : "supervisor")} key={this.indexChats++}>
                  <img src={item.type === 2 ? agentChat : supervisorChat} className={"iconGlobeChat " + (item.type === 2 ? "agent" : "supervisor")} alt="icon" />
                  <div className={"chatGlobe " + (item.type === 2 ? "agent" : "supervisor")}>
                    <p className={"chatGlobeText " + (item.type === 2 ? "agent" : "supervisor")}>{item.text}</p>
                    <p className={"chatGlobeHour " + (item.type === 2 ? "agent" : "supervisor")}>{item.hour.slice(0, -3)}</p>
                  </div>
                </div>)}
            </div>
            <div className="writeArea">
              <div className="writeContainer">
                <TextareaAutosize
                  id="txtMessageChatAdmin"
                  innerRef={ref => this.textarea = ref}
                  className={"textChat " + (this.state.textToSend ? "" : "noText")}
                  maxLength={250}
                  placeholder={this.language.getText("GUIChattoolTipWrite")}
                  onChange={event => this.saveText(event.target.value)}
                  onKeyUp={event => this.handleKeyUp(event)}
                />
                <div className="sendButtonChat" onClick={() => this.sendChat()}>{send}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    messageToSupervisor: (message, supervisor) => { dispatch(messageToSupervisor(message, supervisor)); },
    consultingApp: () => { dispatch(consultingApp()); },
    noConsultingApp: () => { dispatch(noConsultingApp()); },
    changeIsIntegration: () => { dispatch(changeIsIntegration()); },
  });
}
function mapStateToProps(state) {
  return {
    stateMachineActions: state.stateMachineActions,
    messagesIntegrations: state.messagesIntegrations,
  }
}
export default SupervisorChat = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupervisorChat);



// WEBPACK FOOTER //
// ./src/components/workSpace/FloatingSideComponents/ChatComponent.jsx